<template>
  <Teleport to="body">
  <div v-if="show" class="consultant-type-selection-modal-overlay" @click.self="handleCancel">
    <div class="consultant-type-selection-modal" @click.stop>
      <div class="consultant-type-selection-modal-header">
        <h3 class="consultant-type-selection-modal-title">
          <i class="bi bi-person-plus"></i>
          Select Consultant Type
        </h3>
        <button class="consultant-type-selection-modal-close" @click="handleCancel">
          <i class="bi bi-x"></i>
        </button>
      </div>
      
      <div class="consultant-type-selection-modal-body">
        <p class="consultant-type-selection-modal-description">
          Does this consultant have multiple service agreements or a single service agreement?
        </p>
        
        <div class="consultant-type-selection-modal-options">
          <div 
            class="consultant-type-selection-modal-option" 
            :class="{ 'selected': selectedType === 'single' }"
            @click="selectType('single')"
          >
            <div class="consultant-type-selection-modal-option-icon">
              <i class="bi bi-person"></i>
            </div>
            <div class="consultant-type-selection-modal-option-content">
              <h4 class="consultant-type-selection-modal-option-title">Single Service Agreement</h4>
              <p class="consultant-type-selection-modal-option-description">
                This consultant has one service agreement. Customer, vendor and service information is configured directly for the consultant.
              </p>
            </div>
            <div class="consultant-type-selection-modal-option-check">
              <i v-if="selectedType === 'single'" class="bi bi-check-circle-fill"></i>
            </div>
          </div>
          
          <div 
            class="consultant-type-selection-modal-option" 
            :class="{ 'selected': selectedType === 'multiple' }"
            @click="selectType('multiple')"
          >
            <div class="consultant-type-selection-modal-option-icon">
              <i class="bi bi-people"></i>
            </div>
            <div class="consultant-type-selection-modal-option-content">
              <h4 class="consultant-type-selection-modal-option-title">Multiple Service Agreements</h4>
              <p class="consultant-type-selection-modal-option-description">
                This consultant has multiple service agreements. Customer, vendor and service information can be configured separately for each agreement.
              </p>
            </div>
            <div class="consultant-type-selection-modal-option-check">
              <i v-if="selectedType === 'multiple'" class="bi bi-check-circle-fill"></i>
            </div>
          </div>
        </div>
      </div>
      
      <div class="consultant-type-selection-modal-footer">
        <button 
          class="consultant-type-selection-modal-btn consultant-type-selection-modal-btn-cancel" 
          @click="handleCancel"
        >
          Cancel
        </button>
        <button 
          class="consultant-type-selection-modal-btn consultant-type-selection-modal-btn-continue" 
          @click="handleContinue"
          :disabled="!selectedType"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
import './ConsultantTypeSelectionModal.css';

export default {
  name: 'ConsultantTypeSelectionModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'select'],
  data() {
    return {
      selectedType: null // 'single' or 'multiple'
    };
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.selectedType = null;
      }
    }
  },
  methods: {
    selectType(type) {
      this.selectedType = type;
    },
    handleContinue() {
      if (this.selectedType) {
        this.$emit('select', this.selectedType);
      }
    },
    handleCancel() {
      this.selectedType = null;
      this.$emit('close');
    }
  }
};
</script>
